import { DETECTED_ISSUE_ACTION_CONFIGS } from '@/client/services/moderation/constants'
import type { DetectedIssueType } from '@/client/services/moderation/types'

export default function isDetectedIssueDisputable(detectedIssueType: DetectedIssueType): boolean {
  const disableDisputes = DETECTED_ISSUE_ACTION_CONFIGS[detectedIssueType].disableDisputes ?? false

  return !disableDisputes
}
